**Calmar** is defined as the excess return (annualized return - risk-free return)
divided by the negative Max Drawdown.
